import { createFileRoute } from "@tanstack/react-router";
import { QuotaManagementPage } from "@client/components/settings/quota-management/quota-management-page";

export const Route = createFileRoute("/_app/settings/quota-management")({
  component: QuotaManagementPage,
});
